import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detailsRow"]

  toggle(event) {
    const row = event.currentTarget
    const playlistUri = row.dataset.playlistUri
    const dspSite = row.dataset.dspSite

    // Find or create the details row
    let detailsRow = row.nextElementSibling

    if (detailsRow && detailsRow.classList.contains('playlist-details-row')) {
      // Details row exists, toggle it
      if (detailsRow.style.display === 'none') {
        detailsRow.style.display = ''
      } else {
        detailsRow.style.display = 'none'
      }
    } else {
      // Create new details row
      this.loadPlaylistDetails(row, playlistUri, dspSite)
    }
  }

  loadPlaylistDetails(row, playlistUri, dspSite) {
    // Get current filters from URL
    const urlParams = new URLSearchParams(window.location.search)
    const startDate = urlParams.get('start_date')
    const endDate = urlParams.get('end_date')
    const datePreset = urlParams.get('date_preset')
    const territories = urlParams.getAll('territories[]')

    // Build query parameters
    const params = new URLSearchParams()
    params.append('playlist_uri', playlistUri)
    params.append('dsp_site', dspSite)

    if (startDate) params.append('start_date', startDate)
    if (endDate) params.append('end_date', endDate)
    if (datePreset) params.append('date_preset', datePreset)
    territories.forEach(t => params.append('territories[]', t))

    // Create details row
    const detailsRow = document.createElement('tr')
    detailsRow.classList.add('playlist-details-row')
    detailsRow.innerHTML = `
      <td colspan="5" class="p-0">
        <div class="border-t border-gray-200">
          <div class="p-4 bg-gray-50">
            <div class="text-center text-gray-500">
              Loading playlist details...
            </div>
          </div>
        </div>
      </td>
    `

    // Insert after current row
    row.parentNode.insertBefore(detailsRow, row.nextSibling)

    // Fetch playlist details
    fetch(`/trends/playlist_details?${params.toString()}`)
      .then(response => response.text())
      .then(html => {
        detailsRow.querySelector('td').innerHTML = html
      })
      .catch(error => {
        console.error('Error loading playlist details:', error)
        detailsRow.querySelector('td').innerHTML = `
          <div class="p-4 bg-gray-50">
            <div class="text-center text-red-500">
              Error loading playlist details. Please try again.
            </div>
          </div>
        `
      })
  }
}
